import { render, staticRenderFns } from "./PatentEditor.vue?vue&type=template&id=ac914436"
import script from "./PatentEditor.vue?vue&type=script&lang=js"
export * from "./PatentEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports